// Helpers for the role mapping (`requiredBy`) of a course linked to an
// e-learning catalogue course. A role's value is `true` (required; on a
// course with several pathways that means the lowest one), a pathway id, or
// false / missing (not required). Mirrors server helpers/training/pathways.js.

export const catalogueCourseFor = (catalogueCourses = [], code) =>
  (code && catalogueCourses.find((course) => course.code === code)) || null

export const lowestPathway = (pathways = []) => [...pathways].sort((a, b) => a.rank - b.rank)[0] ?? null

// The pathway id a role's value asks for, or null when not required / the
// course has no pathways to choose between.
export const requiredPathwayId = (value, pathways = []) => {
  if (!value || pathways.length === 0) return null
  if (typeof value === 'string' && pathways.some((pathway) => pathway.id === value)) return value
  return lowestPathway(pathways).id
}

// A pathway's short name, for places where the course is already named
// beside it: "Level 1", not "Infection Prevention and Control: Level 1".
export const pathwayShortLabel = (pathway) => pathway?.cstfLevel || pathway?.title || ''

// Level to show beside a requirement, only when there is a real choice.
export const requiredPathwayTitle = (value, catalogueCourse) => {
  const pathways = catalogueCourse?.pathways ?? []
  if (pathways.length < 2) return null
  const id = requiredPathwayId(value, pathways)
  return pathwayShortLabel(pathways.find((pathway) => pathway.id === id)) || null
}

// Form values for the given link: pathway ids when the linked course has
// more than one pathway, plain true/false otherwise. Unknown roles on the
// record are kept as they are.
export const normaliseRequiredBy = (requiredBy = {}, roles = [], pathways = []) => {
  const multi = pathways.length > 1
  const next = { ...requiredBy }
  roles.forEach((role) => {
    const value = requiredBy[role]
    if (!value) next[role] = false
    else next[role] = multi ? requiredPathwayId(value, pathways) : true
  })
  return next
}

export const expiryLabel = (months) => {
  if (!months) return 'no expiry'
  if (months % 12 === 0) return months === 12 ? '1 year' : `${months / 12} years`
  return `${months} months`
}
